import { styled } from "@linaria/react";

import { withTheme } from "../theme/GalaxyTheme";
import type { PropsWithTheme } from "../theme/types";

const HorizontalDividerWrapper = withTheme(styled.div<PropsWithTheme>`
  width: 100%;
  height: 0.5px;
  background-color: ${({ theme }) => theme.color.border.primary};
`);

const HorizontalDivider = () => {
  return <HorizontalDividerWrapper />;
};

export default HorizontalDivider;
